"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _CircleCheckmarkComponent.default;
  }
});

var _CircleCheckmarkComponent = _interopRequireDefault(require("./CircleCheckmark-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }